import { Injectable, inject } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs';
import posthog from 'posthog-js';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  private readonly router = inject(Router);
  private ready = false;

  init(): void {
    if (this.ready || !environment.posthogKey || environment.posthogKey.startsWith('REPLACE')) {
      return;
    }

    posthog.init(environment.posthogKey, {
      api_host: environment.posthogHost,
      person_profiles: 'identified_only',
      capture_pageview: false, // manual: we fire on NavigationEnd below
      persistence: 'localStorage',
    });

    this.ready = true;

    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe(e => posthog.capture('$pageview', { $current_url: e.urlAfterRedirects }));
  }

  identify(email: string, properties?: Record<string, unknown>): void {
    if (!this.ready) return;
    posthog.identify(email, { email, ...properties });
  }

  capture(event: string, properties?: Record<string, unknown>): void {
    if (!this.ready) return;
    posthog.capture(event, properties);
  }
}
